<template>
  <div
    v-if="stage === 'inSale'"
    class="shop-now-btn"
    :class="{ selected: isSelected }"
  >
    {{ $t("shopNow") }}
  </div>
  <div v-else class="shop-now-btn coming-soon">{{ $t("comingSoon") }}</div>
</template>

<script>
export default {
  name: "ShopNowButton",
  props: {
    /**
     * Determines if the button is in selected state
     */
    isSelected: {
      type: Boolean,
      default: false,
    },
    /**
     * Text to display on the button
     */
    buttonText: {
      type: String,
      default: "Shop Now",
    },
  },
  inject: ["stage"],
  methods: {
    /**
     * Handles button click event and emits to parent component
     */
    // handleClick() {
    //   this.$emit("click");
    // },
  },
};
</script>

<style lang="scss" scoped>
@import "~/scss/include/_commonInclude.scss";

.shop-now-btn {
  background: color(successGreen);
  color: color(white);
  border: none;
  border-radius: rem(10);
  padding: rem(12);
  // height: rem(49);
  margin-top: rem(24);
  width: 100%;

  font-weight: 400;
  font-size: rem(20);
  line-height: 1.2;
  letter-spacing: rem(2);
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;

  &.selected {
    display: none;
  }

  &.coming-soon {
    background: #a2a2a2;
    cursor: not-allowed;
  }

  @include media-breakpoint-down(md) {
    padding: rem(12);
    font-size: rem(16);
    margin-top: rem(16);
  }
}
</style>
